import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from '../../core/services/auth.service';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css', '../../shared/styles/common.css'],
    standalone: false
})

export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,private toastr: ToastrService, private data: DataService,
    private snackBar: MatSnackBar
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, this.validateEmailOrMobile.bind(this)]]
    });
  }

  validateEmailOrMobile(control: FormControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (!value) return null;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const mobilePattern = /^[0-9]{10,15}$/;

    if (emailPattern.test(value) || mobilePattern.test(value)) {
      return null;
    }

    return { invalidEmailOrMobile: true };
  }

  detectLoginType(value: string): 'email' | 'mobile' {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(value) ? 'email' : 'mobile';
  }

  ngOnInit(): void {
    // if (this.authService.isLoggedIn()) {
    //   this.router.navigate(['/dashboard']);
    // }
  }

  // onSubmit(): void {
  //   if (this.forgotPasswordForm.valid) {
  //     this.isLoading = true;
  //     const email = this.forgotPasswordForm.get('email')?.value;

  //     this.authService.requestPasswordReset(email).subscribe({
  //       next: (response: { message: string }) => {
  //         this.snackBar.open(response.message || 'Password reset instructions have been sent to your email.', 'Close', { duration: 5000 });
  //         this.router.navigate(['/login']);
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.isLoading = false;
  //         const errorMessage = error.error?.message || 'Failed to send reset instructions. Please try again.';
  //         this.snackBar.open(errorMessage, 'Close', { duration: 3000 });
  //       },
  //       complete: () => {
  //         this.isLoading = false;
  //       }
  //     });
  //   } else {
  //     this.markFormGroupTouched(this.forgotPasswordForm);
  //   }
  // }

  onSubmit(email: string){
   // this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const logintype = this.detectLoginType(email);

    this.authService.forgot_password(email, logintype).subscribe({
  next: (res: HttpResponse<any>) => {
    if (!res.body?.error) {
      localStorage.setItem('reemail', this.forgotPasswordForm.value?.email);
      localStorage.setItem('resetLoginType', logintype);
      localStorage.setItem('coffer_id', res.body.data.coffer_id);

      // this.router.navigate(['/reset-password']);
      this.router.navigate(['/consumer/reset-password'], {
        queryParams: {
          email: email
        }
      });

      this.data.changeCofferId(res.body.coffer_id);
    } else {
      this.toastr.error(res.body.msg || 'Something went wrong', 'Error!');
    }
  },
  error: (err) => {
    if (err.status === 404) {
      this.toastr.error(err.error.msg, 'Error');
    } else {
      this.toastr.error('An unexpected error occurred. Please try again later.', 'Error!');
    }
    console.error('Forgot password error:', err);
  }
});

  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

  restricttextSpace(event: any) {
		let inputValue: string = event.target.value;
		inputValue = inputValue.replace(/^\s+/, '');
		inputValue = inputValue.replace(/\s{2,}/g, ' ');
		event.target.value = inputValue;
		return;
	}

  signIn() {
    this.router.navigate(['/consumer/login'], {
      queryParams: {
        resetSuccess: true,
       // email: this.mail
      }
    });
  }

}